<template>
  <nav-bar :menuItems="menuItems" :portalButton="true" />
</template>
<script>
export default {
	name: "NavigationBarAudit",
	data: () => ({
		menuItems: [
			{ title: "Dashboard", link: "/emissions" },
			{ title: "Supplier Results", link: "/emissions/suppliers" },
		],
		sidebar: false
	})
}
</script>
